<template>
  <div class="Page">
    <!--Banner-->
    <section class="">
        <div class="banner">
            <h1 class="PageTitle" style="">LOCATION DE CAMIONS LOURDS</h1>
        </div>
    </section>
    <!--section bgText-->
    <section>
      <v-row class="bgText">
        <v-row>
            <p>Réseau Dynamique offre un service de location de véhicules variés, neufs et usagés louables à court ou à long terme par l'intermédiaire de la Fiducie Location Pinard et du <router-link to="/concessionaire/thetfordMines">Centre du Camion Amiante.</router-link> En plus de vous conseiller dans le choix d'un camion lourd International ou Ottawa Kalmar, les 7 points de services répartis sur le territoire québécois mettent à votre disposition de nombreux services afin de vous aider à perpétrer vos activités en flux continu.</p>
        </v-row>
        <v-row>
            <v-row>
                <h2 class="titleShortTitle" >Location court terme</h2>
                <p>Le service de location court terme de Réseau Dynamique répond aux besoins ponctuels d’une clientèle diversifiée. Toute entreprise est susceptible d’affronter des situations inattendues pouvant nécessiter l’ajout temporaire de véhicules : achalandage accru, surplus de travail, besoins saisonniers ou véhicules en panne ne constituent que quelques exemples.</p>
                <p class="textCenterShortLoan">Alliant flexibilité et efficacité, le service de location court terme pourrait alors être d’un grand secours advenant de telles situations.</p>
            </v-row>
            <v-row>
              <v-col class="centerListShortTermLoan">
                <h3>Avantages</h3>
                <ul>
                    <li>Contrat de location d’une durée égale ou inférieure à 12 mois</li>
                    <li>Contrat de location incluant ou non notre assurance</li>
                    <li>Service gratuit de rédaction de rapport de taxe sur les carburants</li>
                    <li>Service d’assistance routière 24/7</li>
                    <li>Jouissance des avantages offerts par le programme <img style="max-height: 20px;" src="/ressources/images/logo/Idealease.png" alt="logo de Idealease" /> : si un de nos véhicules tombe en panne au Canada ou aux États-Unis, Réseau Dynamique dispose de 24 heures pour effectuer les réparations majeures faute de quoi le véhicule sera temporairement remplacé</li>
                </ul>
              </v-col>
            </v-row>
        </v-row>


        <p></p>
      </v-row>
    </section>
    <!--section Longterm-->
    <section>
      <v-row class="bgLongTerm">
        <h2 class="sectionTitle">Location long terme </h2>
        <p>Le service de location long terme de Réseau Dynamique répond aux besoins de plus longue durée (période excédant 12 mois) de sa clientèle. Afin de suffire à toutes exigences financières et matérielles, nous avons développé une gamme de solutions variées.</p>
        <v-row>
            <v-col cols="12"><h3>Contrat de location avec entretien</h3></v-col>
            <v-col cols="12"><p>Remise du véhicule au terme du contrat.</p> </v-col>
            <v-col cols="12"><p style="font-weight: 700; color: rgb(var(--primary));">Tous nos plans de location long terme avec entretien comprennent</p></v-col>
            <v-col cols="12">
                <ul>
                    <li>Un service d’entretien préventif régulier</li>
                    <li>Un service de remorquage</li>
                    <li>Un service de remplacement de véhicule</li>
                    <li>L’entretien des pneus</li>
                    <li>Le service d’assistance routière 24/7</li>
                    <li>La disponibilité de plusieurs points de service : Anjou, Boucherville, St-Hyacinthe, Drummondville,</li>
                    <li>Trois-Rivières et Québec</li>
                    <li>D’autres points de service dans tous les concessionnaires International et <img style="max-height: 20px;" src="/ressources/images/logo/Idealease.png" alt="logo de Idealease" /> en Amérique du Nord</li>
                    <li>Dans certaines divisions, un service de valet pour ramener chauffeurs ou camions</li>
                    <li>Un service d’urgence mobile</li>
                    <li>L'inspection gouvernementale (SAAQ)</li>
                </ul>
            </v-col>
            
        </v-row>
      </v-row>
    </section>
    <section>
        <v-row class="bgNoMaintenance">
            <v-col cols="12"><h2 class="sectionTitle">Contrat de location sans entretien</h2></v-col>
            <v-col cols="12"><p><span class="bold">Crédit-bail :</span> rachat du véhicule au terme du contrat.</p></v-col>
            <v-col cols="12"><p style="padding-top: 20px;"><span class="bold">Contrat de location directe :</span> remise du véhicule au terme du contrat.</p></v-col>
            <v-col cols="12">
                <ul>
                    <li>Taux d’intérêt compétitif</li>
                    <li>Flexibilité de financement</li>
                </ul>
            </v-col>
            <v-col cols="12"><p style="padding-top: 20px;"> Renseignez-vous auprès de l'une des 7 succursales pour en connaître davantage sur le service de location court et long terme.</p></v-col>
        </v-row>
    </section>
    <section style="height: 100%; position: relative;" class="">
      <v-row class="">
        <v-col cols="12" class="bgServiceGray"><h2 class="sectionTitle txt-c">NOS CONCESSIONNAIRE</h2></v-col>
        <v-row class="bgDealers">
          <v-row style="margin-top: -125px !important;">
            <v-col  v-for="(item,i) in rentalDealers" :key="i" class="bgDealer">
                <div v-if="item.emergency" class="card dealerFront">
                  <img class="dealerImg" :src="item.emergency.img" />
                  <v-row class="d-flex align-center textDealerFront" style="">
                    <v-col cols="12">
                      <h2 class="town txt-c">{{ item.town }}</h2>
                      <p class="name">{{ item.name }}</p>
                    </v-col>
                  </v-row>

                </div>
                <div class="card dealerBack" >
                  <img class="imgDealerBack" style="" src="/ressources/images/emergency/baseSquare.jpg" />
                  <v-row class="textDealerBack" style="">
                    <v-col cols="12"><h2 class="town">{{ item.town }}</h2></v-col>
                    <v-row cols="12" class="d-flex align-center" style="margin-top: 20px;">
                      <v-col style="max-width: 75px; min-width: 75px;">
                        <img class="icon" src="/ressources/images/emergency/telEmergency.png" />
                      </v-col>
                      <v-col>
                        <v-col cols="12" class="d-flex align-center"><a class="phoneText" :href="'tel:' + item.emergency.phone" style="" v-html="item.emergency.phone"></a></v-col>
                        <v-col cols="12" v-if="item.emergency.openHours"><p style="font-size: 12px; color: white; padding-left: 10px;" >Selon les heures d’ouverture</p></v-col>
                      </v-col>                 
                    </v-row>
                    <v-col cols="12" class="d-flex align-center">
                      <h2 style="color: rgb(var(--primary)); font-size: 48px; font-family: TxtOffRe; font-weight: 700; text-align: right; max-width: 75px; min-width: 75px;">></h2>
                      <router-link :to="item.path"><p v-if="!item.emergency.towingPhone" class="fiche">Voir plus de détails</p><p class="fiche" v-else>Besoin d’un remorquage ?</p></router-link>
                    </v-col>
                  </v-row>
                </div> 
            </v-col>
          </v-row>
          
        </v-row>
      </v-row>
      
    </section>
      <!--all services-->
    <section id="allServices">
      <v-row class="allServicesBG">
        <v-col><h2>DÉCOUVREZ L’ENSEMBLE DE NOS SERVICES</h2></v-col>
      </v-row>
      <v-row>
          <v-col class="serviceSection bgservice">
            <router-link to="/services"><h2 class="sectionTitle serviceSubtitle">SERVICE</h2></router-link>
          </v-col>
          <v-col class="serviceSection bgparts" style="">
            <router-link to="/piece"><h2 class="sectionTitle serviceSubtitle">PIÈCES</h2></router-link>
          </v-col>
          <v-col class="serviceSection bgSales" style="">
            <router-link to="/ventes"><h2 class="sectionTitle serviceSubtitle">Ventes</h2></router-link>
          </v-col>
        </v-row>
    </section>
  </div>
</template>
<style scoped>
    p { font-family: TxtOffRe; } 
    a {color: rgb(var(--secondary));}
    a:hover {text-decoration: underline;}
    h2 { color: rgb(var(--primary)); font-size: 32px;}
    h3 { margin: 20px 0px;}
    ul { padding-left: 20px; }
    .banner { position: relative; min-height: 400px; max-width:100%; background-image: url('../../public/ressources/images/emergency/banner.jpg'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
    .PageTitle { position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); text-align: center; }
    
    .bgText {background-color: rgb(var(--ligthGray)); padding: 100px;}
    .sectionTitle { color: white;  } 

    .titleShortTitle { margin-top: 20px; text-align: center; width: 100%; }
    .centerListShortTermLoan { max-width: 50%; margin: auto; }
    .textCenterShortLoan { width: 100%; text-align: center; }

    .bgText p { padding-top: 25px;  font-family: TxtOffRe;}
    .bgLongTerm { background-color: rgb(var(--gray)); padding: 100px; }
    .bgLongTerm p { color: rgb(var(--white)); }
    .bgLongTerm h3 { color: rgb(var(--secondary)); font-size: 24px; }
    .bgLongTerm ul { padding: 20px 0px 0px 40px; color: white; }

    .bgNoMaintenance { background-color: rgb(var(--ligthGray)); padding: 100px; }
    .bgNoMaintenance h2 { color: rgb(var(--primary)); }



    .bgServiceGray { background-color: black; padding: 100px 0px 150px 0px !important; }
    .bgDealer { position: relative; max-width: 450px; min-width: 450px; height: 350px; margin: 20px auto; perspective: 1000px;  }
    .dealerImg { position: absolute; z-index: 10; height: 100%; width: 100%; }
    .bgDealers { padding: 50px 5%; background-color: rgb(var(--ligthGray));}
    .fiche { padding-left: 10px; display: inline-block; color: white; cursor: pointer; }
    .fiche:hover { color: rgb(var(--secondary)); }
    .town { font-family: TxtOffBDI; text-transform: uppercase; color: #FFFFFF; }
    .name { font-family: TxtOffRe; color: #FFFFFF; text-align: center; }
    .textDealerFront { position: relative; z-index: 100; padding: 40px; width: 100%; height: 100%; }
    .imgDealerBack { position: absolute; z-index: 10; max-width: 450px; min-width: 450px; height: 350px; }
    .textDealerBack { position: relative; z-index: 100; padding: 40px; width: 100%; height: 100%; }
    .icon { display: inline-block; height: 75px; width: auto; }
    .phoneText {padding-left: 10px; display: inline-block; color: white; font-size: 24px;}
    .emailText { font-size: small;  padding-left: 10px; display: inline-block; color: rgb(var(--secondary)); cursor: pointer;}
    .card { width: 100%; height: 100%; position: absolute; backface-visibility: hidden; transition: transform 0.6s; }
    .dealerBack { transform: rotateY(180deg); }
    .bgDealer:hover .dealerBack { transform: rotateY(0deg); }
    .bgDealer:hover .dealerFront { transform: rotateY(180deg); }

    /*#region allServices*/
      .allServicesBG { background-color: rgb(var(--gray)); }
      .allServicesBG h2 { text-align: center; color: white; padding: 100px 0px; font-size: 36px; font-family: TxtOffBDI; }
      .bgSales { background-image: url('../../public/ressources/images/home/serviceSales.png'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
      .bgparts { background-image: url('../../public/ressources/images/home/PIECES.png'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
      .bgservice { background-image: url('../../public/ressources/images/home/SERVICE.png'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
      .bglocation { background-image: url('../../public/ressources/images/home/LOCATION.png'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
      .serviceTitle { font-family: TxtOffBDI; padding: 10% 0px; text-align: center; margin: 10px 0px !important; text-transform: uppercase; color: white; }
      .serviceSubtitle { font-family: TxtOffBDI; padding: 30% 0px; text-align: center; margin: 10px 0px; text-transform: uppercase; color: white; }
      .serviceSection:hover  .serviceTitle {color: rgb(var(--primary)); cursor: pointer; text-decoration: none !important;}
      .serviceSection:hover  .serviceSubtitle {color: rgb(var(--primary)); cursor: pointer; text-decoration: none !important;}
      a { text-decoration: none !important; }
    /*#endregion*/

    @media handheld, only screen and (max-width: 600px) {
      h2 { font-size: 24px; }
      .bgDealer { position: relative; max-width: 350px; min-width: 100%; height: 350px; margin: 20px auto; perspective: 1000px;  }
    }
    @media handheld, only screen and (max-width: 960px) {
      .bgText { padding: 10px; text-align: justify;}
      .bgWhy { padding: 10px; }
      .centerListShortTermLoan {max-width:95%;}
      .bgLongTerm { padding:5px; }
      .bgNoMaintenance { padding:5px; }
    }
    @media handheld, only screen and (max-width: 1279px) {}
    @media handheld, only screen and (max-width: 1378px) {}
</style>
<script>

export default {
  name: 'Home',
  data:()=>({
    whyUs:[
      { title:"Service courtois, fiable&nbsp;et&nbsp;sécuritaire", img:"/ressources/images/dealer/serviceRoutier.png" },
      { title:"Véhicules de dépannage équipés d’outils spécialisés, pièces et technologies&nbsp;de&nbsp;pointe", img:"/ressources/images/dealer/ServiceRemorquage.png" },
      { title:"Service de location de camion selon&nbsp;la&nbsp;succursale", img:"/ressources/images/dealer/cle.png" },
      { title:"Équipe de professionnels dévoués&nbsp;hautement&nbsp;certifiés", img:"/ressources/images/dealer/atelierCarrosserie.png" }
    ],
    rentalDealers: null,
  }),
  async mounted() {
    this.dataRead();
  },
  methods:{
    dataRead: async function () {
        try {
            const response = await fetch('/ressources/json/dealers.json');
            if (!response.ok) {
                throw new Error('Failed to fetch');
            }
            let dealers = await response.json();
            let rentalDealers = [];
            for (const key in dealers) { if(dealers[key].rental == true) {  rentalDealers.push(dealers[key]); } }
            if(rentalDealers.length > 0) { this.rentalDealers = rentalDealers; }
            

        } catch (error) {
            console.error('Error loading JSON data:', error);
        }
    },
  },

  components: { }
}
</script>
